import axios from 'axios';
import { identificationType } from '../constants';

export function actionObj(type, payload) {
  return {
    type,
    payload,
  };
}

export const parameterFactory = {
  [identificationType.pii]: ({ pii }, metadata, token) => ({
    pii, metadata, token,
  }),
  [identificationType.doi]: ({ doi }, metadata, token) => ({
    doi: encodeURIComponent(doi), token,
  }),
};

export function createParameters(idType, identification, metadata, token) {
  const factory = parameterFactory[idType];
  return factory ? factory(identification, metadata, token) : null;
}

/**
 * Method to return an absolute url if enhancementsBaseUrl is available
 *
 * @param relativePath
 * @returns {string}
 */
export function createUrl(relativePath) {
  return window.config && window.config.enhancementsBaseUrl
    ? `${window.config.enhancementsBaseUrl}${relativePath}`
    : relativePath;
}

export function createFetcher(loadingAction, receivedAction, failedAction) {
  return function fetcher(path) {
    return (dispatch) => {
      dispatch({ type: loadingAction });

      return axios.get(createUrl(path))
        .then(({ data }) => dispatch(actionObj(receivedAction, data)))
        .catch(() => dispatch({ type: failedAction }));
    };
  };
}
